<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}} （{{ CorpInfo.CorpName }}）
      </template>
      <template slot="btn">
        <el-button type="primary"
                   @click="exportExcel()"
                   size="medium">{{$t('task.ExportToFile')}}</el-button>
      </template>
      <template slot="tab">
        <el-tabs @tab-click="changeStatus"
                 v-model="tab">
          <el-tab-pane :label="$t('task.All')"
                       name="All"></el-tab-pane>
          <el-tab-pane v-for=" i of taskType"
                       :key="i.Value"
                       :label="$t('task.'+i.Value)"
                       :name="i.Value"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="search">
        <el-input v-model="condition.Name"
                  :placeholder="$t('task.SearchTaskName')"
                  size="mini"
                  style="margin-left:16px"
                  clearable
                  @change="search()"></el-input>
        <SortControl @sortList="sortList"
                     :orderBy="sortValue">
          <template slot="sort">
            <el-select size="mini"
                       @change="order"
                       placeholder="Orderby"
                       v-model="sortBy">
              <el-option v-for="item in sortType"
                         :key="item.name"
                         :label="item.name"
                         :value="item.value"></el-option>
            </el-select>
          </template>
        </SortControl>
      </template>
    </sub-header>
    <filter-box :showFilter="filter.showFilter"
                @clearFilter="clearFilter()"
                @closeFilter="closeFilter()">
      <template slot="form">
        <el-form :model="condition"
                 label-position="top"
                 size="mini"
                 ref="filter">
          <el-form-item :label="$t('task.Plan')"
                        prop="Name">
            <el-select v-model="condition.PlanId"
                       filterable
                       remote
                       clearable
                       @visible-change="showSelect"
                       size="mini"
                       style="width:100%"
                       :remote-method="remotePlanMethod"
                       @change="search()">
              <el-option v-for="i of planList"
                         :key="i.PlanId"
                         :label="i.Name"
                         :value="i.PlanId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('task.Name')"
                        prop="Name">
            <el-input :placeholder="$t('task.Name')"
                      clearable
                      @change="search()"
                      size="mini"
                      v-model="condition.Name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('task.Status')"
                        prop="Status">
            <el-select :placeholder="$t('task.Status')"
                       clearable
                       size="mini"
                       @change="search()"
                       v-model="condition.Status">
              <el-option v-for=" i of taskStatus"
                         :key="i.Value"
                         :label="i.Key"
                         :value="i.Value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('task.TaskGroup')"
                        prop="GroupId">
            <el-select v-model="condition.GroupId"
                       clearable
                       filterable
                       remote
                       @visible-change="showGroupSelect"
                       :remote-method="remoteGroupMethod"
                       @change="search()"
                       size="mini">
              <el-option v-for="i of groupList"
                         :key="i.PhaseId"
                         :label="i.Name"
                         :value="i.PhaseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('task.LocationType')"
                        prop="LocationType">
            <el-select v-model="condition.LocationType"
                       clearable
                       @change="search()"
                       size="mini">
              <el-option :label="$t('task.Floor')"
                         value="1"></el-option>
              <el-option :label="$t('task.Wall')"
                         value="2"></el-option>
              <!-- <el-option :label="$t('task.Elevation')"
                         value="4"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('task.DueDate')">
            <el-row>
              <el-col :span="11">
                <el-form-item prop="DueStartTime">
                  <el-date-picker type="date"
                                  @change="search()"
                                  v-model="condition.DueStartTime"
                                  size="mini"
                                  style="width: 100%;"
                                  :placeholder="$t('task.Start')"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col style="text-align:center"
                      :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="DueEndTime">
                  <el-date-picker type="date"
                                  @change="search()"
                                  v-model="condition.DueEndTime"
                                  size="mini"
                                  style="width: 100%;"
                                  :placeholder="$t('task.End')"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('task.Watching')"
                        prop="WatchingUserIds">
            <el-select :placeholder="$t('model.Select')"
                       clearable
                       size="mini"
                       @change="search()"
                       v-model="condition.WatchingUserIds">
              <el-option v-for="i of user"
                         :key="i.UserId"
                         :label="i.FullName"
                         :value="i.UserId">
                <div class="user-logo">
                  <img :src="i.AvatarUrl"
                       alt="">
                </div>
                <span style="margin-left:40px;">{{ i.FullName }}({{ i.LoginAccount }})</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </filter-box>
    <div class="main"
         :class="{'main-showfilter': filter.showFilter || batchDialog.showDialog || taskDialog.showDialog}">
      <div class="tool-btn">
        <el-button type="primary"
                   size="mini"
                   v-has="'Edit Tasks'"
                   :disabled="this.batchDialog.id.length < 1"
                   @click="handleEditClick">{{$t('task.BatchEdit')}}</el-button>
        <el-button type="danger"
                   v-has="'Delete Task'"
                   size="mini"
                   :disabled="this.batchDialog.id.length < 1"
                   @click="batchDelete">{{$t('task.BatchDelete')}}</el-button>
        <span style="float: right;">
          <el-badge is-dot
                    class="item"
                    :hidden='this.hasCondition'>
            <el-button type="success"
                       style="float:right"
                       @click="openFilter()"
                       size="mini">{{$t('task.Filters')}}</el-button>
          </el-badge>
        </span>
      </div>
      <div class="table-box">
        <myScroll style="width:100%;height:100%">
          <el-table :data="list"
                    ref="taskTable"
                    size="small"
                    v-loading="loading"
                    :highlight-current-row="false"
                    @row-click="handleClick"
                    :row-class-name="tableRowClassName"
                    @selection-change="handleSelectionChange"
                    style="position:absolute"
                    :row-key="getRowKeys">
            <el-table-column v-if="userInfo.RoleType !== 4"
                             type="selection"
                             :reserve-selection="true"
                             width="55">
            </el-table-column>
            <el-table-column v-else
                             header-align="center"
                             width="5">
            </el-table-column>
            <el-table-column width="55">
              <template slot-scope="scope">
                <svg-icon :iconClass="scope.row.icon"
                          :class="scope.row.color"></svg-icon>
              </template>
            </el-table-column>
            <el-table-column :label="$t('task.Name')">
              <template slot-scope="scope">
                <span :class="scope.row.color!== 'danger'?'':'danger'">
                  {{scope.row.Name}}
                </span>
                <el-progress :percentage="scope.row.CompletionRate"
                             v-if="scope.row.TaskType !== 2"></el-progress>
                <p v-if="scope.row.Concrete"
                   :class="scope.row.color"
                   style="margin:0"> {{$t('task.Concrete')}}:{{scope.row.Concrete}}%</p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('task.Plan')">
              <template slot-scope="scope">
                {{scope.row.PlanName?scope.row.PlanName:'-'}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('task.Project')">
              <template slot-scope="scope">
                {{scope.row.JobsiteName}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('task.DueDate')">
              <template slot-scope="scope">
                {{scope.row.EndDate?scope.row.EndDate.substring(0,10): '-'}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('task.Group')">
              <template slot-scope="scope">
                {{scope.row.TaskPhaseName}}
              </template>
            </el-table-column>
          </el-table>
        </myScroll>
      </div>
      <page ref="pagination"
            :total="total"
            :PageSize="condition.PageSize"
            :PageIndex="condition.PageIndex"
            @handleCurrentChange="handleCurrentChange"></page>
    </div>

    <Batch-dialog :showDialog="batchDialog.showDialog"
                  :id="batchDialog.id"
                  @closeDialog="closeBatch"></Batch-dialog>
    <Task-dialog :showDialog="taskDialog.showDialog"
                 @closeDialog="closeTaskDialog"
                 @changeRate="changeRate"
                 :id="taskDialog.id"></Task-dialog>
  </div>
</template>

<script>
import { getTasksList, deleteTask, getCorpUser, getPlansList, getTaskGroup } from '@/api/config'
import { mapState } from 'vuex'
import BatchDialog from '@components/task/batchDialog'
import TaskDialog from '@components/task/taskDialog'
import SortControl from '@components/common/sortBtnList'
export default {
  data () {
    return {
      loading: false,
      taskDialog: {
        showDialog: false,
        id: ''
      },
      batchDialog: {
        showDialog: false,
        id: []
      },
      filter: {
        showFilter: true
      },
      Assignee: '',
      Watching: '',
      user: [],
      condition: {
        Type: null,
        Name: null,
        Status: null,
        GroupId: null,
        DueStartTime: null,
        DueEndTime: null,
        LastUpdatedOn: null,
        PageIndex: 1,
        PageSize: 20,
        GetChildTask: false,
        GetRecycle: false,
        IsApp: false,
        AssignedUserIds: null,
        WatchingUserIds: null,
        OnlyMyTask: true,
        LocationType: null,
        PlanId: null,
        OrderBy: 'LastUpdatedOn desc'
      },
      total: 0,
      list: [],
      tab: 'All',
      planList: [],
      planCondition: {
        Name: null,
        PageIndex: 1,
        PageSize: 20,
        OrderBy: 'LastUpdatedOn desc'
      },
      groupList: [],
      groupCondition: {
        Name: null,
        PageIndex: 1,
        PageSize: 20,
        OrderBy: 'CreatedOn desc'
      },
      CorpInfo: {
        CorpName: ''
      },
      sortType: [
        {
          name: this.$t('task.Name'),
          value: 'Name'
        }, {
          name: this.$t('task.CreatedOn'),
          value: 'CreatedOn'
        }, {
          name: this.$t('task.UpdatedOn'),
          value: 'LastUpdatedOn'
        }, {
          name: this.$t('task.DueDate'),
          value: 'EndDate'
        }],
      sortValue: 'desc',
      sortBy: 'LastUpdatedOn'
    }
  },
  computed: {
    ...mapState(['taskStatus', 'taskType', 'taskWorkType', 'userInfo', 'taskConditionOrderby']),
    hasCondition: {
      get () {
        return (this.condition.Name == null || this.condition.Name === '') &&
          (this.condition.PlanId == null || this.condition.PlanId === '') &&
          (this.condition.Status == null || this.condition.Status === '') &&
          (this.condition.GroupId == null || this.condition.GroupId === '') &&
          (this.condition.LocationType == null || this.condition.LocationType === '') &&
          (this.condition.DueStartTime == null || this.condition.DueStartTime === '') &&
          (this.condition.DueEndTime == null || this.condition.DueEndTime === '') &&
          (this.condition.WatchingUserIds == null || this.condition.WatchingUserIds === '')
      }
    }
  },
  created () {
    this.getCorpUser()
    this.$store.dispatch('diag/getTasksProgressOptions')
    this.$store.dispatch('getTaskWorkTypes')
    this.$store.dispatch('getTasksStatus')
    this.$store.dispatch('getTaskChecklistTemplates')
    this.$store.dispatch('getTasksTypes').then(
      this.setTaskConditionOrderBy(),
      this.getTasksList()
    )
    this.getPlansList()
    this.getTaskGroups()
    this.openFilter()
    this.CorpInfo.CorpName = this.$store.state.corpName
  },
  mounted () {

  },
  watch: {
  },
  methods: {
    changeRate (task) {
      this.list.forEach((element, index) => {
        if (element.TaskId === task.TaskId) {
          var curTask = this.list[index]
          curTask.CompletionRate = task.CompletionRate
          curTask.Status = task.Status
          curTask.CompletionDate = task.CompletionDate
          if (curTask.TaskType === 2 && task.LastRHReading) {
            curTask.LastRHReading = {
              ConcreteRH: task.LastRHReading.ConcreteRH
            }
          }
        }
      })
      this.list = this.$config.handleTaskList(this.list)
    },
    closeTaskDialog (needRefresh) {
      this.taskDialog.id = ''
      this.taskDialog.showDialog = false
      if (needRefresh === true) {
        this.getTasksList()
      }
    },
    showTaskDialog (row) {
      this.taskDialog.id = row.TaskId
      this.batchDialog.showDialog = false
      this.filter.showFilter = false
      this.taskDialog.showDialog = true
    },
    closeBatch (needRefresh) {
      this.batchDialog.showDialog = false
      if (needRefresh === true) {
        this.getTasksList()
      }
    },
    handleEditClick () {
      this.filter.showFilter = false
      if (this.batchDialog.id.length === 1) {
        this.taskDialog.id = this.batchDialog.id[0]
        this.batchDialog.showDialog = false
        this.taskDialog.showDialog = true
      } else if (this.batchDialog.id.length > 1) {
        this.batchDialog.showDialog = true
        this.taskDialog.showDialog = false
      }
    },
    clearFilter () {
      this.$refs['filter'].resetFields()
      this.condition.PlanId = null
      this.search()
    },
    closeFilter () {
      this.filter.showFilter = false
    },
    async openFilter () {
      this.batchDialog.showDialog = false
      this.filter.showFilter = true
      this.taskDialog.showDialog = false
    },
    getCorpUser () {
      let condition = {
        PageIndex: 1,
        PageSize: 100,
        OrderBy: 'CreatedOn desc'
      }
      getCorpUser(condition).then(res => {
        res.Data.forEach(ele => {
          ele.AvatarUrl = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId + '?isAvatar=true'
        })
        this.user = res.Data
      })
    },
    changeStatus (tab, event) {
      this.condition.PageIndex = 1
      if (tab.name !== 'All') {
        this.taskType.forEach(res => {
          if (tab.name === res.Value) {
            this.condition.Type = res.Key
          }
        })
      } else {
        this.condition.Type = null
      }
      this.taskDialog.id = ''
      this.taskDialog.showDialog = false
      this.getTasksList()
      this.$refs['taskTable'].clearSelection()
      this.batchDialog.id = []
      this.batchDialog.showDialog = false
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getTasksList()
    },
    sortList (type) {
      if (type === 'asc') {
        this.sortValue = 'desc'
      } else {
        this.sortValue = 'asc'
      }
      this.order()
    },
    order () {
      this.condition.OrderBy = this.getTaskConditionOrderBy()
      this.saveTaskConditionOrderBy()
      this.getTasksList()
    },
    getTasksList () {
      this.loading = true
      getTasksList(this.condition).then(res => {
        this.total = res.TotalCount
        this.list = this.$config.handleTaskList(res.Data)
        this.loading = false
      })
    },
    search () {
      this.condition.PageIndex = 1
      if (!this.condition.AssignedUserIds) {
        this.condition.AssignedUserIds = null
      }
      if (!this.condition.WatchingUserIds) {
        this.condition.WatchingUserIds = null
      }
      if (!this.condition.LocationType) {
        this.condition.LocationType = null
      }
      this.getTasksList()
    },
    handleClick (row) {
      if (this.batchDialog.id.length !== 1 || this.batchDialog.id[0] !== row.TaskId) {
        this.batchDialog.id = []
        this.$refs['taskTable'].clearSelection()
      }
      this.showTaskDialog(row)
    },
    handleSelectionChange (val) {
      this.batchDialog.id = []
      val.forEach(res => {
        this.batchDialog.id.push(res.TaskId)
      })
      if (this.batchDialog.id.length === 0) {
        this.taskDialog.showDialog = false
        this.batchDialog.showDialog = false
      } else if (this.batchDialog.id.length === 1) {
        this.showTaskDialog(val[0])
      } else if (this.batchDialog.id.length > 1) {
        this.batchDialog.showDialog = true
        this.taskDialog.id = ''
        this.taskDialog.showDialog = false
      }
    },
    batchDelete () {
      if (this.batchDialog.id.length < 1) {
        this.$notify.info({
          title: this.$t('task.PleaseCheckOneTaskAtLast')
        })
        return
      }
      this.$confirm(this.$t('task.AreYouSureYouWantToDeleteTheseTasks'), this.$t('task.TIPS'), {
        confirmButtonText: this.$t('task.Yes'),
        cancelButtonText: this.$t('task.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        deleteTask(this.batchDialog.id).then(res => {
          this.$refs.pagination.handleDelete(this.batchDialog.id.length)
        })
      }).catch(() => {
      })
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let condition = {
        Type: this.condition.Type,
        Name: this.condition.Name,
        Status: this.condition.Status,
        GroupId: this.condition.GroupId,
        DueStartTime: this.condition.DueStartTime,
        DueEndTime: this.condition.DueEndTime,
        LastUpdatedOn: this.condition.LastUpdatedOn,
        PageIndex: 1,
        PageSize: 1000,
        GetChildTask: this.condition.GetChildTask,
        GetRecycle: this.condition.GetRecycle,
        IsApp: this.condition.IsApp,
        AssignedUserIds: this.condition.AssignedUserIds,
        WatchingUserIds: this.condition.WatchingUserIds,
        PlanId: this.condition.PlanId,
        LocationType: this.condition.LocationType,
        OnlyMyTask: true,
        OrderBy: this.condition.OrderBy
      }
      getTasksList(condition).then(res => {
        res.Data.forEach(ele => {
          ele.CompletionRateText = this.$config.getFormatNumber(ele.CompletionRate)
          if (ele.EndDate) {
            ele.EndDate = this.$config.LocalTime(ele.EndDate).substring(0, 10)
          }
        })
        require.ensure([], () => {
          // eslint-disable-next-line camelcase
          const { export_json_to_excel } = require('../../../excel/Export2Excel')
          const tHeader = [this.$t('task.Name'), this.$t('task.CompletionRate'), this.$t('task.Plan'), this.$t('task.Project'), this.$t('task.DueDate'), this.$t('task.Assignee'), this.$t('task.Group')]
          const filterVal = ['Name', 'CompletionRate', 'PlanName', 'ProjectName', 'EndDate', 'AssignedUserNames', 'TaskPhaseName']
          const list = res.Data
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, this.$t('task.' + this.tab) + '_excel')
          loading.close()
        })
      })
    },
    getRowKeys (row) {
      return row.TaskId
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    tableRowClassName ({ row, rowIndex }) {
      if (this.taskDialog.id === row.TaskId) {
        return 'success-row'
      }
    },
    showSelect (e) {
      if (!e) {
        this.planCondition.Name = null
        this.getPlansList()
      }
    },
    remotePlanMethod (query) {
      this.planCondition.Name = query
      this.getPlansList()
    },
    getPlansList () {
      this.planCondition.JobsiteId = this.jobsiteID
      getPlansList(this.planCondition).then(res => {
        this.planList = res.Data
      })
    },
    showGroupSelect (e) {
      if (!e) {
        this.groupCondition.Name = null
        this.getTaskGroups()
      }
    },
    remoteGroupMethod (query) {
      this.groupCondition.Name = query
      this.getTaskGroups()
    },
    getTaskGroups () {
      this.groupCondition.JobsiteId = this.jobsiteID
      getTaskGroup(this.groupCondition).then(res => {
        this.groupList = res.Data
      })
    },
    getTaskConditionOrderBySplit () {
      return ' '
    },
    getTaskConditionOrderBy () {
      return this.sortBy + this.getTaskConditionOrderBySplit() + this.sortValue
    },
    setTaskConditionOrderBy () {
      let arr = this.taskConditionOrderby.split(this.getTaskConditionOrderBySplit())
      if (arr && arr.length === 2) {
        this.sortBy = arr[0]
        this.sortValue = arr[1]
      }
    },
    saveTaskConditionOrderBy () {
      this.$store.commit('setTaskConditionOrderby', this.condition.OrderBy)
    }
  },
  components: {
    BatchDialog,
    TaskDialog,
    SortControl
  }
}
</script>
<style lang="scss">
.el-tabs__nav-wrap::after {
  background: none;
}
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style lang="scss" scoped>
.table-box {
  flex: 1;
  height: 0;
  margin: 0 8px;
  border: 1px solid #dcdfe6;
  .table-icon {
    width: 24px;
  }
  .svg-icon {
    font-size: 28px;
  }
}

.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
